
import { Component, HostListener, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { SectionComponent } from '../../ui/section-component/section-component';
import { MenuSidebar } from '../../ui/menu-sidebar/menu-sidebar';
import { SidebarComponent } from '../../ui/sidebar/sidebar';
import { facade } from './facade';
import { PopoverComponent } from '../../ui/popover/popover';
import { AuthRolesService } from '@core/guard/authorization/authorization-guard';
import { ServiceNotification } from '../../services/notification/service-notification';
import { AuthApi } from '@features/login/data-access/auth-api';
import { UserSessionService } from '@core/services/session/user-session.service';
import { ButtonComponent } from '../../ui/button/button';
import { Tooltip } from 'primeng/tooltip';

@Component({
	selector: 'app-layout',
	imports: [
    SectionComponent,
    RouterOutlet,
    MenuSidebar,
    SidebarComponent,
    ButtonComponent,
    Tooltip
],
	standalone: true,
	templateUrl: './app-layout.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './app-layout.css',
})
export class AppLayout implements OnInit {
	constructor(
		private facade: facade,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private authenticateService: AuthApi,
		private serviceNotification: ServiceNotification,
		private userSession: UserSessionService,
	) {}
	isMobileView: boolean = false;
	sidebarVisible: boolean = true;
	userName: string = '';
	farmName: string = '';
	pageTitle: string = '';

	ngOnInit() {
		this.checkScreenSize();
		this.userName = this.userSession.userName() || '';

		const farmId = this.userSession.farmId();
		if (farmId) {
			this.facade
				.getFarmByIdFacade(farmId)
				.subscribe((farmName) => {
					this.farmName = farmName;
				});
		}

		this.updatePageTitle();
		this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe(() => {
				if (this.isMobileView) this.sidebarVisible = false;
				this.updatePageTitle();
			});
	}

	private updatePageTitle() {
		let route = this.activatedRoute.firstChild;
		while (route?.firstChild) {
			route = route.firstChild;
		}
		this.pageTitle = route?.snapshot.data['title'] || '';
	}

	closeSidebarOnMobile() {
		this.sidebarVisible = false;
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.checkScreenSize();
	}

	checkScreenSize() {

		const wasMobileView = this.isMobileView;
		this.isMobileView = window.innerWidth <= 768;

		if (this.isMobileView !== wasMobileView) {
			this.sidebarVisible = !this.isMobileView;
		}
	}

	logoutMenu() {
		this.authenticateService.logout().subscribe({
			next: () => {
				this.serviceNotification.success(
					'Sucesso!',
					'Você saiu do sistema.',
				);
				this.router.navigate(['/login']);
			},
			error: (err: any) => {
				this.serviceNotification.error(
					'Erro!',
					err.error.message || 'Não foi possível sair do sistema.',
				);
				this.router.navigate(['/login']);
			},
		});
	}
}
